import { useCallback, useMemo, useState } from "react";

import AIScribeAction from "../Api/AIScribeAction";

interface IUseAIScribeStartConsultationParams {
    encounterId: string;
    onAIScribeSubscriptionInactive?: () => void;
    onAIScribeConsultationCreated?: (
        consultationId: string,
        url: string,
        encounterId: string,
    ) => void;
}

export function useAIScribeStartConsultation({
    encounterId,
    onAIScribeSubscriptionInactive,
    onAIScribeConsultationCreated
}: IUseAIScribeStartConsultationParams): {
        startConsultation: () => Promise<void>;
        isLoading: boolean;
    } {
    const [isLoading, setIsLoading] = useState(false);
    const action = useMemo(() => new AIScribeAction(), []);

    const startConsultation = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await action.startAsync(encounterId);
            if (!response.IsActiveSubscription) {
                onAIScribeSubscriptionInactive?.();
            }
            else if (response.Consultation) {
                onAIScribeConsultationCreated?.(
                    response.Consultation.ConsultationId,
                    response.Consultation.Url,
                    encounterId
                );
            }
        }
        finally {
            setIsLoading(false);
        }
    }, [
        action,
        encounterId,
        onAIScribeSubscriptionInactive,
        onAIScribeConsultationCreated
    ]);

    return { startConsultation, isLoading };
}
